import { registerTemplate } from '@contentpepper-publisher/theme-hospitality';

export const availableTemplates: any = [registerTemplate()];

export const activeTemplates = ['theme-hospitality'];
